import { css } from '@emotion/css';
const text = css `
  margin-bottom: 4px;
`;
const button = css `
  padding: 8px !important;
`;
export const FinderPatternStyles = {
    text,
    button,
};
//# sourceMappingURL=FinderPattern.styles.js.map